import React from 'react'
import { EmailHistoryTab } from './EmailSettingTab'

export const EmailFeature = (): JSX.Element => {
  return <EmailHistoryTab />
}
